// extracted by mini-css-extract-plugin
export var deleteModal = "_em-0";